import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Utilities } from '../providers/utilities';
import { Database } from '../providers/database';

@Injectable()

export class NotesData {
  listenerController: any;
  tokenEvent: String;

  constructor(public af: AngularFire, public auth: AuthData, public ut: Utilities, public db: Database) {
  }

  getListNotes(client: any, token_event) {
    if (this.auth.getUser()) {
      return this.af.database.list('/Clients/' + client.url + '/Events/' + token_event + '/Notes/' + this.auth.getUser().uid, {
        query: {
          orderByChild: 'timestamp'
        }
      });
    }
  }

  create(client: any, dataObject: any, token_event) {
    dataObject.uid = this.auth.getUser().uid;
    dataObject.email = this.auth.getUser().email || 'Anonymous';
    dataObject.timestamp = new Date().getTime();

    return this.db.pushData('/Clients/' + client.url + '/Events/' + token_event + '/Notes/' + this.auth.getUser().uid, dataObject);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/notes.ts